export default __webpack_public_path__ + "static/footer-badge-4-d79f0a6c25d80ee40428c10277047abf.svg";